import React, { useState } from 'react';

import { IconButton, Menu, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

import { iconButtonSx, menuPaperSx, menuItemSx } from './styles';

import { ReactComponent as MoreVertIcon } from 'asset/IconsPack/hx_dots-vertical-filled.svg';

function MoreOption({ disabled, handleDeleteBrand }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const handleClick = (event) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    const onClickOption = () => {
        setAnchorEl(null);
        handleDeleteBrand();
    };

    return (
        <>
            <IconButton
                sx={iconButtonSx}
                aria-controls={openMenu ? 'edit-brand-option' : undefined}
                aria-expanded={openMenu ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                disabled={disabled}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="edit-brand-option"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: menuPaperSx,
                    },
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem onClick={onClickOption} sx={menuItemSx}>
                    Delete
                </MenuItem>
            </Menu>
        </>
    );
}

MoreOption.propTypes = {
    handleDeleteBrand: PropTypes.func,
    disabled: PropTypes.bool,
};

export default MoreOption;
